"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MoreHoriz_1 = __importDefault(require("@mui/icons-material/MoreHoriz"));
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const lodash_1 = __importDefault(require("lodash"));
const teamTable_1 = require("./teamTable");
const lexico = new lexico_1.default();
const getTableData = (teams, onActionButtonClick) => {
    if (teams && teams.length > 0) {
        return teams.map(team => [
            {
                id: 'teamName',
                ui() {
                    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, direction: "column", children: [(0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: team?.name, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitleName', children: team?.name || '' }) }), (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "subtitle1", "ts-variant": 'tableCellSubtitle', children: ["Owners: ", (0, teamTable_1.getAdminNames)(team)] })] }));
                },
            },
            {
                id: 'teamNumberOfMembers',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitle', children: team.numberOfMembers || 0 }));
                },
            },
            {
                id: 'teamNumberofVirtualCards',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitle', children: team.isCardLimitExceeded ? lexico.trc('Data not available', 'N/A') : team.numberOfCards || 0 }));
                },
            },
            {
                id: 'teamSourceCards',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: team.sourceCards.length < 2 ? (team.sourceCards[0] ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, direction: "column", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitle', children: team.sourceCards[0].name }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle1", "ts-variant": 'tableCellSubtitle', children: `#${lodash_1.default.get(team, 'sourceCards[0].lastDigits', '∗∗∗∗')}` })] })) : ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle1", "ts-variant": 'tableCellSubtitleSC', children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'No Physical Cards' : 'No Source Cards' }) }))) : ((0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, direction: "column", children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "subtitle2", "ts-variant": 'tableCellTitle', children: [team.sourceCards.length, (0, jsx_runtime_1.jsx)("span", { children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'PHYSICAL CARDS' : 'SOURCE CARDS' })] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle1", "ts-variant": 'tableCellSubtitleSC', children: team.sourceCards
                                        .map(function (elem) {
                                        return `#${lodash_1.default.get(elem, 'lastDigits', '∗∗∗∗')}`;
                                    })
                                        .join(', ') })] })) }));
                },
            },
            {
                id: 'teamState',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", "ts-variant": team.state === 'ACTIVE' ? 'active' : 'inactive', children: team.state }));
                },
            },
            {
                id: 'teamActions',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "row", sx: {
                            justifyContent: 'flex-end',
                            alignItems: 'flex-end',
                        }, children: (0, jsx_runtime_1.jsx)(material_1.Button, { "data-testid": "row-actions-btn", variant: "text", "ts-variant": "actionButton", onClick: () => onActionButtonClick('Team actions', team), children: (0, jsx_runtime_1.jsx)(MoreHoriz_1.default, {}) }) }));
                },
            },
        ]);
    }
    return [];
};
exports.getTableData = getTableData;
